import { AdhesionMode } from './getAdhesionDetails';
import parseArcaResponse from '../parseArcaResponse';

/**
 * Cambia el importe de la aportación periódica.
 *
 * `userEppConfigId` es el plan CONCRETO (`user_epp_config.id`). Mismo motivo que
 * en el día de cobro: `mode` no nombra una fila, y con dos planes del mismo tipo
 * el backend responde `PLAN_REQUIRED` en vez de elegir. Escribir el importe en
 * el plan que no era es cobrar cada mes donde no toca.
 */
const updatePeriodicalContribution = async (
	token: string,
	pensionContribution: number,
	contributeAlwaysMax: boolean = false,
	mode?: AdhesionMode,
	userEppConfigId?: string
) => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/update-periodical-contribution`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({
				pensionContribution,
				contributeAlwaysMax,
				...(mode ? { mode } : {}),
				...(userEppConfigId ? { userEppConfigId } : {})
			})
		}
	);

	return parseArcaResponse(response);
};

export default updatePeriodicalContribution;
